<template>
  <div class="mt-6 w-full">
    <div>
      <div>
        <p class="text-lg font-bold text-root-2">Transactions</p>
      </div>
      <div class="card bg-root w-full p-6 mt-4">
        <div class="mt-6" v-if="isLoading">
          <spinner
            size="medium"
            :spacing="40"
            message=""
            :line-fg-color="$primaryColor"
          />
        </div>
        <div v-else>
          <div>
            <el-tabs v-model="activeTab" @tab-click="handleClick">
              <el-tab-pane
                label="Treasury"
                name="firstTab"
                v-if="tenantPermission('api-treasury-access')"
              >
                <transactions-table
                  :tableData="treasuryTableData"
                  tableType="treasury"
                  tableUse="transactionHistory"
                  :page="treasuryPage"
                  @getTreasuryTransactions="getTreasuryTransactions"
                />
              </el-tab-pane>
              <el-tab-pane :label="terminalTabLabel" name="secondTab">
                <transactions-table
                  :tableData="terminalTableData"
                  tableType="terminal"
                  tableUse="transactionHistory"
                  :page="terminalPage"
                  @getTerminalTransactions="getTerminalTransactions"
                />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getTreasuryTransactions from '@/mixins/externalApi.js'
import tenant from '@/mixins/tenant.js'
export default {
  name: 'TransactionHistory',
  mixins: [getTreasuryTransactions, tenant],
  data () {
    return {
      activeTab: 'firstTab',
      terminalTabLabel: '',
      isLoading: false,
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: ''
      }
    }
  },
  components: {
    TransactionsTable: () =>
      import('@/components/externalApi/tables/TransactionsTable.vue')
  },
  methods: {
    handleClick (tab) {
      return tab
    }
  },
  mounted () {
    this.getTreasuryTransactions()
    this.getTerminalTransactions()
    if (!this.tenantPermission('api-treasury-access')) {
      this.activeTab = 'secondTab'
    } else {
      this.activeTab = 'firstTab'
      this.terminalTabLabel = 'Terminal'
    }
  },
  computed: {
    treasuryTableData () {
      return this.$store.state.externalApi.treasuryTransactions.items || []
    },
    treasuryPage () {
      return this.$store.state.externalApi.treasuryTransactions.page
    },
    terminalTableData () {
      return this.$store.state.externalApi.terminalTransactions.items || []
    },
    terminalPage () {
      return this.$store.state.externalApi.terminalTransactions.page
    }
  }
}
</script>

<style scoped>
>>> .el-tabs__item.is-active {
  color: var(--color-primary);
}
>>> .el-tabs__active-bar.is-top {
  background: var(--color-primary);
}
>>> .el-tabs__item:hover {
  color: var(--color-primary);
}
>>> .el-input__inner {
  border-radius: 28px;
  height: 30px;
}
>>> .el-tabs__item {
  color: var(--text-4);
}
.card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 2px 4px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
}
</style>
